import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { FaChevronDown, FaChevronUp, FaQuestionCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Faqs = () => {
    const faqItems = [
        {
            question: "What services does EduWealth offer?",
            answer: "EduWealth offers a range of financial services including mutual funds, investment advisory, and educational courses on personal finance."
        },
        {
            question: "How can I create an account?",
            answer: "You can create an account by clicking on the 'Sign Up' button on the top right corner of the homepage and filling out the registration form."
        },
        {
            question: "What payment methods are accepted?",
            answer: "We accept various payment methods including credit/debit cards, net banking, and UPI for purchasing our services."
        },
        {
            question: "How do I reset my password?",
            answer: "To reset your password, click on the 'Forgot Password' link on the login page and follow the instructions to receive a password reset link via email."
        },
        {
            question: "Is my personal information secure?",
            answer: "Yes, we prioritize your privacy and use advanced security measures to protect your personal and financial information."  
        }
    ];

    const [expandedFaq, setExpandedFaq] = useState(null);

    const toggleFaq = (index) => {
        setExpandedFaq(expandedFaq === index ? null : index);
    };

    return (
        <div className='min-h-screen flex justify-center items-center px-4 py-8'>
            <motion.div 
                className="w-full max-w-6xl mx-auto"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.8 }}
            >
                {/* Header Section */}
                <div className="text-center mb-6 md:mb-8 lg:mb-10">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 px-2">
                        Frequently Asked <span className="text-[#02ca02]">Questions</span>
                    </h2>
                    <p className="mt-2 sm:mt-3 text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
                        Find quick answers to common questions about our services
                    </p>
                </div>
                
                {/* FAQ Items */}
                <div className="space-y-3 sm:space-y-4 max-w-4xl mx-auto">
                    {faqItems.map((faq, index) => (
                        <motion.div 
                            key={index} 
                            className="border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.1, delay: index * 0.1 }}
                        >
                            <button
                                className="flex justify-between items-center w-full p-3 sm:p-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors"
                                onClick={() => toggleFaq(index)}
                                aria-expanded={expandedFaq === index}
                                aria-controls={`faq-content-${index}`}
                            >
                                <div className="flex items-start sm:items-center space-x-2 sm:space-x-3">
                                    <FaQuestionCircle className="text-[#02ca02] mt-0.5 flex-shrink-0 text-sm sm:text-base" />
                                    <span className="font-medium text-gray-900 text-sm sm:text-base text-left">
                                        {faq.question}
                                    </span>
                                </div>
                                {expandedFaq === index ? (
                                    <FaChevronUp className="text-gray-500 flex-shrink-0 ml-2 text-sm sm:text-base" />
                                ) : (
                                    <FaChevronDown className="text-gray-500 flex-shrink-0 ml-2 text-sm sm:text-base" />
                                )}
                            </button>
                            
                            {expandedFaq === index && (
                                <motion.div 
                                    id={`faq-content-${index}`}
                                    className="p-3 sm:p-4 bg-white border-t border-gray-200"
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.1 }}
                                    role="region"
                                    aria-labelledby={`faq-question-${index}`}
                                >
                                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                                        {faq.answer}
                                    </p>
                                </motion.div>
                            )}
                        </motion.div>
                    ))}
                </div>

                {/* Additional Mobile-friendly Contact Info */}
                <div className="text-center mt-6 sm:mt-8 px-4">
                    <p className="text-xs sm:text-sm text-gray-500">
                        Still have questions? <Link to='/contact' className="text-[#02ca02] font-medium">Contact our support team</Link>
                    </p>
                </div>
            </motion.div>
        </div>
    )
}

export default Faqs